<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Section 1: Add New Status -->
    <div class="flx-modal__header w-f3">
        <div class="with-desc">
            <h2>Filter Options</h2>
            <div class="sub">Refine your schedule</div>
        </div>

        <button class="icon-btn" pTooltip="Close" (click)="onCancelClick()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

        <div class="flx-modal__body skim">
           
             <!-- Status -->
            <div class="status-field" *ngIf="data?.filterType != 'BrythumLeft'">
                <label class="field-label">Status</label>
                <div class="field-row field-row--auto">
                    <p-dropdown
                    [placeholder]="translate?.general.messages.none"
                    [options]="jobStatusOptions"
                    optionLabel="fieldLabel"
                    optionValue="id"
                    [filter]="true"
                    [ngModel]="filteredOptions.jobOrderStatusesId"
                    (ngModelChange)="filteredOptions.jobOrderStatusesId = $event"
                    (onChange)="onAddJobStatus()">
                    </p-dropdown>
                </div>
                <div class="status-chip-row_0" *ngIf="jobStatusAssignments?.length > 0">
                    <div class="status-chip status-chip--profile" *ngFor="let js of jobStatusAssignmentsSpliced">
                    <span class="status-chip__text">{{ js?.fieldLabel }}</span>
                    <button type="button" class="status-chip__remove" (click)="removeJobStatus(js)">
                        <i class="fa-regular fa-xmark"></i>
                    </button>
                    </div>
                    <button *ngIf="jobStatusAssignments?.length > 10" type="button" class="status-chip-row_0__toggle" (click)="onShowMoreToggle('jobStatus')">
                    {{ showAllJobStatuses ? "Show Less" : "Show More" }}
                     <i class="fa-regular fa-circle-ellipsis"></i>
                    </button>
                </div>
            </div>

             <!-- User Group -->
            <div class="status-field" *ngIf="data?.filterType === 'BrythumLeft'">
                <label class="field-label">User Group</label>
                <div class="field-row field-row--auto">
                    <p-dropdown
                    [placeholder]="translate?.general.messages.none"
                    [options]="userGroups"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    [ngModel]="filteredOptions.userGroupIds"
                    (ngModelChange)="filteredOptions.userGroupIds = $event"
                    (onChange)="onAddUserGroup()">
                    </p-dropdown>
                </div>
                <div class="status-chip-row_0" *ngIf="userGroupAssignments?.length > 0">
                    <div class="status-chip status-chip--profile" *ngFor="let ug of userGroupAssignmentsSpliced">
                    <span class="status-chip__text">{{ ug?.name }}</span>
                    <button type="button" class="status-chip__remove" (click)="removeUserGroup(ug)">
                        <i class="fa-regular fa-xmark"></i>
                    </button>
                    </div>
                    <button *ngIf="userGroupAssignments?.length > 10" type="button" class="status-chip-row_0__toggle" (click)="onShowMoreToggle('userGroup')">
                    {{ showAllUserGroups ? "Show Less" : "Show More" }}
                     <i class="fa-regular fa-circle-ellipsis"></i>
                    </button>
                </div>
            </div>
            <!-- Job Type -->
             <div class="status-field" *ngIf="data?.filterType != 'BrythumLeft'">
                <label class="field-label">Job Type</label>
                <div class="field-row field-row--auto">
                  <p-dropdown 
                    [placeholder]="translate?.general.messages.none" 
                    [options]="jobTypeOptions"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"         
                    [ngModel]="filteredOptions.joTypeIds"
                    (ngModelChange)="filteredOptions.joTypeIds = $event"
                    (onChange)="onAddJOType()">
                    </p-dropdown>
                </div>

                <!-- Chip Rows -->
                <div class="status-chip-row_0" *ngIf="jobTypeAssignments?.length > 0">
                    <div class="status-chip status-chip--profile" *ngFor="let jt of jobTypeAssignmentsSpliced; index as i">
                        <span class="status-chip__text">{{ jt?.name }}</span>
                        <button type="button" class="status-chip__remove" (click)="removeJobType(jt, i)">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>
                   

                    <button *ngIf="jobTypeAssignments?.length > 10" type="button" class="status-chip-row_0__toggle" (click)="onShowMoreToggle('jobType')">
                     {{ showAllJobTypes ? "Show Less" : "Show More" }}
                    <i class="fa-regular fa-circle-ellipsis"></i>
                    <!-- <i class="fa-regular fa-circle-chevron-up" *ngIf="!showAllJobTypes"></i> -->
                    </button>
                </div>
            </div>

            
             <!-- Due Window -->
            <div class="status-field" *ngIf="data?.filterType != 'BrythumLeft'">
                <label class="field-label">Created Date </label>
                
                <div class="field-row field-row--auto">
                    <p-calendar 
                   type="text"
                    class="custella-calendar"
                    dateFormat="dd/mm/yy"
                    name="dueDate"
                    [placeholder]="translate?.general.messages.none"
                    selectionMode="range"
                    [(ngModel)]="dateRange"
                    (ngModelChange)="onDateChange($event)"
                    [yearNavigator]="true"
                    yearRange="2000:2030"
                    [showButtonBar]="false"
                    id="picklist_AssetNextMaintenanceDateField"
                    #myCalendar
                    appendTo="body">
                    </p-calendar>
                    
                </div>
            </div>
           

            <!-- Service Zone -->
            <div class="status-field">
            <label class="field-label">Service Zone</label>
            <div class="field-row field-row--auto">
                <p-dropdown
                [placeholder]="translate?.general.messages.none"
                [options]="serviceZones"
                optionLabel="name"
                optionValue="id"
                [filter]="true"
                [ngModel]="filteredOptions.serviceZoneIds"
                (ngModelChange)="filteredOptions.serviceZoneIds = $event"
                (onChange)="onAddServiceZone()">
                </p-dropdown>
            </div>
            <div class="status-chip-row_0" *ngIf="serviceZoneAssignments?.length > 0">
                <div class="status-chip status-chip--profile" *ngFor="let sz of serviceZoneAssignmentsSpliced">
                <span class="status-chip__text">{{ sz?.name }}</span>
                <button type="button" class="status-chip__remove" (click)="removeServiceZone(sz)">
                    <i class="fa-regular fa-xmark"></i>
                </button>
                </div>
                <button *ngIf="serviceZoneAssignments?.length > 10" type="button" class="status-chip-row_0__toggle" (click)="onShowMoreToggle('serviceZone')">
                {{ showAllServiceZones ? "Show Less" : "Show More" }}
               <i class="fa-regular fa-circle-ellipsis"></i>
                </button>
            </div>
            </div>

            <!-- Access -->
            <div class="status-field" *ngIf="data?.filterType === 'BrythumLeft'">
            <label class="field-label">Access</label>
            <div class="field-row field-row--auto">
                <p-dropdown
                [placeholder]="translate?.general.messages.none"
                [options]="profilesList"
                optionLabel="name"
                optionValue="name"
                [filter]="true"
                [ngModel]="filteredOptions.userAccessLevels"
                (ngModelChange)="filteredOptions.userAccessLevels = $event"
                (onChange)="onAddProfile()">
                </p-dropdown>
            </div>
            <div class="status-chip-row_0" *ngIf="profileAssignments?.length > 0">
                <div class="status-chip status-chip--profile" *ngFor="let profile of profileAssignmentsSpliced">
                <span class="status-chip__text">{{ profile?.name }}</span>
                <button type="button" class="status-chip__remove" (click)="removeProfile(profile)">
                    <i class="fa-regular fa-xmark"></i>
                </button>
                </div>
                <button *ngIf="profileAssignments?.length > 10" type="button" class="status-chip-row_0__toggle" (click)="onShowMoreToggle('profile')">
                {{ showAllProfiles ? "Show Less" : "Show More" }}
               <i class="fa-regular fa-circle-ellipsis"></i>
                </button>
            </div>
            </div>

            <!-- Online Status -->
            <div class="status-field" *ngIf="data?.filterType === 'BrythumLeft'">
            <label class="field-label">Online Status</label>
            <div class="field-row field-row--auto">
                <p-dropdown
                [placeholder]="translate?.general.messages.none"
                [options]="onlineUsersList"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [ngModel]="filteredOptions.userOnlineStatuses"
                (ngModelChange)="filteredOptions.userOnlineStatuses = $event"
                >
                </p-dropdown>
            </div>
            
            </div>
            <!-- Customer -->
             <div class="status-field" *ngIf="data?.filterType != 'BrythumLeft'">
                <label class="field-label">{{translate?.customer.label.singular}}</label>
                <div class="field-row field-row--auto">
                  <div class="p-inputgroup search">
                                    <span class="p-input-icon-right w-100">
                                        <p-autoComplete 
                                        (onBlur)="onvalidCustomer()"
                                        (onSelect)="selectCustomerValue($event)"
                                         field="name"
                                        [suggestions]="customers" 
                                        (completeMethod)="getCustomer($event)"
                                            [(ngModel)]="selectedCustomer" 
                                            [ngModelOptions]="{ standalone: true }"
                                            id="picklist_JobCustomerField" 
                                            styleClass="w-100"
                                            (onClear)="clearValue('customer')">
                                        </p-autoComplete>
                                        <i *ngIf="filteredOptions.customerIds != null" (click)="clearValue('customer')"
                                            id="btn_JobCustomerClear" class="p-autocomplete-clear-icon pi pi-times"></i>
                                    </span>
                                    <button type="button" pButton icon="fa-regular fa-magnifying-glass"
                                        [pTooltip]="translate?.customer.tooltips.customerLookup.singular"
                                        tooltipPosition="left" id="btn_JobCustomerSearch"
                                        (click)="showTable('customer')"></button>
                                </div>
                                <footer *ngIf="showCustomer" class="custella-form-container-footer hidePopup">
                                    <p-dialog [header]="translate?.jobOrder.sections.sec2.singular"
                                        id="title_CusDetails" [(visible)]="showCustomer" showEffect="fade"
                                        [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
                                        <app-custella-customers (selectCustomerEvent)="selectCustomerFromTable($event)"
                                            (closeCustomerEvent)="closeCustomerView()"></app-custella-customers>
                                    </p-dialog>
                                </footer>
                </div>
            </div>

             <!-- Asset -->
             <div class="status-field" *ngIf="data?.filterType == 'Scheduler'">
                <label class="field-label">{{translate?.asset.label.singular}}</label>
                <div class="field-row field-row--auto">
                  <div class="p-inputgroup search">
                                    <span class="p-input-icon-right w-100">
                                        <p-autoComplete 
                                            (onBlur)="onvalidAsset()"
                                            (onSelect)="selectAssetFromTable($event)"
                                            field="name"
                                            [suggestions]="assets" 
                                            (completeMethod)="getAsset($event)"
                                            [(ngModel)]="selectedAsset" 
                                            [ngModelOptions]="{ standalone: true }"
                                            id="picklist_JobAssetField" 
                                            styleClass="w-100"
                                            (onClear)="clearValue('asset')">
                                        </p-autoComplete>
                                        <i *ngIf="filteredOptions.assetIds != null" (click)="clearValue('asset')"
                                            id="btn_JobAssetClear" class="p-autocomplete-clear-icon pi pi-times"></i>
                                    </span>
                                    <button type="button" pButton icon="fa-regular fa-magnifying-glass"
                                        [pTooltip]="translate?.asset.tooltips.assetLookup.singular"
                                        tooltipPosition="left" id="btn_JobAssetSearch"
                                        (click)="showTable('asset')"></button>
                                </div>
                                 <footer *ngIf="showAsset" class="custella-form-container-footer hidePopup">
                                    <p-dialog [header]="translate?.jobOrder.sections.sec1.singular"
                                        id="title_AssetDetails" [(visible)]="showAsset" showEffect="fade"
                                        [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
                                        <app-custella-assets (closeAssetView)="closeAssetView()"
                                            (assetSelector)="gotSelectedAsset($event)"></app-custella-assets>
                                    </p-dialog>
                                </footer>
                </div>
            </div>
            <!-- Required Skills -->
             <!-- <div class="status-field">
                <label class="field-label">Required Skills</label>
                <div class="field-row field-row--auto">
                    <p-dropdown [placeholder]="translate?.general.messages.none" [showClear]="true">
                    </p-dropdown>
                </div>

                <div class="status-chip-row_0" >
                    <div class="status-chip status-chip--profile">
                        <span class="status-chip__text">Example 1 Chip</span>
                        <button type="button" class="status-chip__remove">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>
                    <div class="status-chip status-chip--profile">
                        <span class="status-chip__text">Example 2 Chip</span>
                        <button type="button" class="status-chip__remove">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>
                    <div class="status-chip status-chip--profile">
                        <span class="status-chip__text">Example 3 Chip</span>
                        <button type="button" class="status-chip__remove">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>

                    <button
                    type="button"
                    class="status-chip-row_0__toggle"
                    >
                    Show More
                    <i class="fa-regular fa-circle-ellipsis"></i>
                    </button>
                </div>
            </div> -->
           <!-- Asset Type -->
            <div class="status-field" *ngIf="data?.filterType == 'Backlog'">
            <label class="field-label">{{translate?.asset.label.singular}}&nbsp;{{translate?.setup.modules.picklist.asset.type.label.singular}}</label>
            <div class="field-row field-row--auto">
                <p-dropdown
                [placeholder]="translate?.general.messages.none"
                [options]="assetTypes"
                optionLabel="label"
                optionValue="id"
                [filter]="true"
                [ngModel]="filteredOptions.assetTypeId"
                (ngModelChange)="filteredOptions.assetTypeId = $event"
                (onChange)="onAddAssetType()">
                </p-dropdown>
            </div>
            <div class="status-chip-row_0" *ngIf="assetTypeAssignments?.length > 0">
                <div class="status-chip status-chip--profile" *ngFor="let at of assetTypeAssignmentsSpliced">
                <span class="status-chip__text">{{ at?.label }}</span>
                <button type="button" class="status-chip__remove" (click)="removeAssetType(at)">
                    <i class="fa-regular fa-xmark"></i>
                </button>
                </div>
                <button *ngIf="assetTypeAssignments?.length > 10" type="button" class="status-chip-row_0__toggle" (click)="onShowMoreToggle('assetType')">
                {{ showAllAssetTypes ? "Show Less" : "Show More" }}
                <i class="fa-regular fa-circle-ellipsis"></i>
                </button>
            </div>
            </div>
        </div>

    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="onCancelClick()">{{translate?.general.buttons.cancel.singular }}</button>
         <p-button type="button" [label]="translate?.general.buttons.clear.singular" styleClass="h-32 dark" (onClick)="onClear()"></p-button>
        <p-button styleClass="h-32" type="button" [label]="translate?.general.buttons.confirm.singular" (onClick)="onConfirmClick()"></p-button>
    </div>
</div>